// ----------------------------------------------------------------------------
// Component: Content Cards
// ----------------------------------------------------------------------------
//
// Section displaying a default card consisting of an image,
// title, content and button. It displays a 1, 2 or 3 column grid.
//
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper, { Scrollbar, A11y, Keyboard } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';
import 'snippets/swiper-control/swiper-control';

// Style includes
import './_content-cards.scss';
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';


// -------------------------------------
// Variables
// -------------------------------------
const CAROUSEL_SELECTOR = '.carousel--content-cards';
const CAROUSEL_CLASS = 'carousel--content-cards';
const CAROUSEL_SECTION_SELECTOR = '.carousel-section--content-cards';
const CAROUSEL_SCROLLBAR_SELECTOR = '.swiper-scrollbar';

// -------------------------------------
// Hooks
// -------------------------------------
document.querySelectorAll(CAROUSEL_SECTION_SELECTOR)?.forEach((element, index) => {
    
    // Generate unique class for each collection list slider
    element.querySelector(CAROUSEL_SELECTOR)?.classList.add(`${CAROUSEL_CLASS}-${index}`);
    
    // Generate unique btn classes for scroll bar
    element.querySelector(CAROUSEL_SCROLLBAR_SELECTOR)?.classList.add(`${CAROUSEL_CLASS}-scrollbar-${index}`);

    const swiper = new Swiper(`.${CAROUSEL_CLASS}-${index}`, {
        // Optional parameters
        modules: [ Scrollbar, A11y, Keyboard],
        slidesPerView: 1.1,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        a11y: false,
        watchOverflow: true,
        scrollbar: {
            el: `.${CAROUSEL_CLASS}-scrollbar-${index}`,
            draggable: true
        },
        breakpoints: {
            // when window width is >= 680px
            680: {
                slidesPerView: 10,
                spaceBetween: 0
            }
        },
    });

    swiper.slides.forEach(function(slide, index) {
        const slideLink = slide.querySelector('a');
        slideLink?.addEventListener('focus', function() {
            swiper.slideTo(index);
        });
    });
});
